import "./style.css";
const p = 160, x = 180, e = "35px", r = "320px", m = "640px", o = "960px", t = "1280px", C = "8px", c = "16px", n = "4px", s = "0.5rem", a = "#0C2A4DCC", b = "0.25rem", d = "0.5rem", g = "1rem", i = "640px", k = "960px", l = "1280px", A = "0.5rem";
export {
  A,
  C,
  a,
  b,
  c,
  d,
  e,
  g,
  i,
  k,
  l,
  m,
  n,
  o,
  p,
  r,
  s,
  t,
  x
};
